import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/required-uuid-string.js';
import { requiredClearableField } from './required-clearable-field.js';
const INVALID_STAFF_MESSAGE = 'Invalid LeafLink staff member.';
// payment_recorded_by_staff_id is an int4 column with CHECK (> 0).
const MAX_INT4 = 2_147_483_647;
export const setLeafLinkPaymentRecordedByStaffArgsSchema = z.object({
    leafLinkIntegrationId: requiredUuidString('LeafLink company is required.', 'Invalid LeafLink company.'),
    staffId: requiredClearableField('staffId', z
        .number({ error: INVALID_STAFF_MESSAGE })
        .int(INVALID_STAFF_MESSAGE)
        .min(1, INVALID_STAFF_MESSAGE)
        .max(MAX_INT4, INVALID_STAFF_MESSAGE)
        .nullable()),
});
//# sourceMappingURL=set-leaflink-payment-recorded-by-staff-args-schema.js.map